import React from 'react';
import Utils from '../../../lib/utils';

interface Props {
  onKeepAlive: (...args: unknown[]) => unknown;
  autoRedirect?: boolean;
  hasActiveSession?: boolean;
}

class KeepAlive extends React.Component<Props> {
  keepAliveFrequency: number;
  intervalId?: ReturnType<typeof setTimeout>;

  constructor(props: Props) {
    super(props);
    this.keepAliveFrequency = Utils.getSetting('KEEP_ALIVE_FREQUENCY');
  }

  componentDidMount() {
    this.keepAlive();
  }

  componentDidUpdate() {
    if (this.props.hasActiveSession)
      this.intervalId = setInterval(
        this.keepAlive,
        this.keepAliveFrequency * 1000
      );
    else clearInterval(this.intervalId);
  }

  keepAlive = () => {
    this.props.onKeepAlive({ autoRedirect: this.props.autoRedirect });
  };

  render() {
    return false;
  }
}

export default KeepAlive;
